"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ObjectsSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M7.56252709,2.47163769 L9.79780601,6.33308168 C10.3229028,6.11835605 10.8976296,6 11.5,6 C13.9852814,6 16,8.01471863 16,10.5 C16,12.9852814 13.9852814,15 11.5,15 C9.18383439,15 7.27636972,13.2501433 7.02750023,11.0003241 L2.62739073,11 C2.16527327,11.0003241 1.79594574,10.4713561 2.06486365,10.0243264 L6.43747291,2.47163769 C6.71618652,2.0320282 7.29039001,2.0320282 7.56252709,2.47163769 Z M11.5,7 C11.0803758,7 10.6779993,7.07384632 10.3051572,7.20925227 L11.9351364,10.0243264 C12.1589508,10.4233246 11.9351364,10.9999503 11.3726093,11 L8.03543731,10.9999503 C8.27803074,12.6961216 9.73674681,14 11.5,14 C13.4329966,14 15,12.4329966 15,10.5 C15,8.56700338 13.4329966,7 11.5,7 Z M7,3.49586349 L3.23444728,10 L10.7655527,10 L7,3.49586349 Z" })));
};
ObjectsSmall.displayName = 'ObjectsSmall';
exports.default = ObjectsSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ObjectsSmall.js.map